import { useNavigate, useSearch } from "@tanstack/react-router";
import { Suspense } from "react";
import {
	Tabs,
	TabsIndicator,
	TabsList,
	TabsPanel,
	TabsTab,
} from "@/components/Tabs";
import { AccountSettings } from "./components/AccountSettings";
import { BillingSettings } from "./components/BillingSettings";
import { BillingSettingsSkeleton } from "./components/BillingSettingsSkeleton";
import { SecuritySettings } from "./components/SecuritySettings";
import { SubscriptionSettings } from "./components/SubscriptionSettings";
import { SubscriptionSettingsSkeleton } from "./components/SubscriptionSettingsSkeleton";

export function SettingsPage() {
	const { tab } = useSearch({ from: "/_app/settings" });
	const navigate = useNavigate();

	return (
		<Tabs
			value={tab}
			onValueChange={(val) =>
				navigate({
					to: "/settings",
					search: (prev) => ({
						...prev,
						tab: val as "account" | "security" | "subscription" | "billing",
					}),
				})
			}
			className="w-full"
		>
			<TabsList className="mb-8">
				<TabsTab value="account">Account</TabsTab>
				<TabsTab value="security">Security</TabsTab>
				<TabsTab value="subscription">Subscription</TabsTab>
				<TabsTab value="billing">Billing</TabsTab>
				<TabsIndicator />
			</TabsList>

			<TabsPanel value="account">
				<AccountSettings />
			</TabsPanel>
			<TabsPanel value="security">
				<SecuritySettings />
			</TabsPanel>
			<TabsPanel value="subscription">
				<Suspense fallback={<SubscriptionSettingsSkeleton />}>
					<SubscriptionSettings />
				</Suspense>
			</TabsPanel>
			<TabsPanel value="billing">
				<Suspense fallback={<BillingSettingsSkeleton />}>
					<BillingSettings />
				</Suspense>
			</TabsPanel>
		</Tabs>
	);
}
